const digest = 'eaa2a2363942c900bb5db4ce61f74577d4d65abb1bb5e51d00f930fd08eab76f';
const css = `._footer_1vk98_2{background-color:#fff;border-top:1px solid #e6e6e6;box-sizing:border-box;margin-top:auto;padding:1.25rem 1.5rem;text-align:center;width:100%}._footer_1vk98_2 a{color:#06c;font-size:1.875rem;font-weight:600;padding-bottom:.9375rem;text-decoration:none;transition:color .2s ease}._footer_1vk98_2 a:hover{color:#0052a3;text-decoration:underline}._footer_1vk98_2 a>span{display:none}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'footer': '_footer_1vk98_2' };
export const footer = '_footer_1vk98_2';
export { css, digest };